import React, { useState } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button/Button";
import Slide from "@material-ui/core/Slide/Slide";
import SectionHeader from "../../../../components/UI/SectionHeader";
import IconButton from "@material-ui/core/IconButton";
import { Close } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import PercentageNumber from "../../../../components/UI/PercentageNumber";
import Divider from "@material-ui/core/Divider";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { Decimal } from "decimal.js";

const styles = (theme) => ({
  modalCloseBtn: {
    position: "absolute",
    top: 10,
    right: 10,
  },
  slider: {
    width: "calc(100% - 70px)",
    marginLeft: 30,
    "& .MuiSlider-valueLabel": {
      left: "calc(-50% - 2px)",
      top: -34,
      textAlign: "center",
      "& *": {
        background: "transparent",
        color: theme.palette.common.black,
      },
    },
  },
  sliderLegend: {
    display: "flex",
    justifyContent: "space-between",
    "& p": {
      width: 70,
      textAlign: "center",
    },
  },
});

const PortfolioAdvisorFeeModal = (props) => {
  const [portfolioAdvisorFee, setPortfolioAdvisorFee] = useState(
    new Decimal(props.portfolioAdvisorFee)
  );

  const adjustFee = (adjustment) => (e) => {
    setPortfolioAdvisorFee(portfolioAdvisorFee.plus(adjustment));
  };

  const { classes, open, handleCloseModal, baseAdvisorFee } = props;
  const feeAdjustment = portfolioAdvisorFee
    .minus(props.baseAdvisorFee)
    .toNumber();
  return (
    <Dialog
      open={open}
      TransitionComponent={Slide}
      TransitionProps={{ direction: "up" }}
      onClose={handleCloseModal}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      maxWidth={"lg"}
      scroll={"paper"}
      classes={{ paper: classes.paper }}
      aria-labelledby="portfolio-advisor-fee-adjustment-modal-title"
      aria-describedby="portfolio-advisor-fee-adjustment-modal-description"
    >
      <DialogTitle
        disableTypography
        id="portfolio-advisor-fee-adjustment-modal-title"
      >
        <SectionHeader text={"Advisor Fee"} />
        <Typography variant="body1">
          Fee adjustments apply only to the selected portfolio, going forward.
        </Typography>
        <IconButton
          className={classes.modalCloseBtn}
          aria-label="Close"
          onClick={handleCloseModal}
        >
          <Close color="primary" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          justify={"center"}
          alignItems={"center"}
          style={{ textAlign: "center" }}
        >
          <Grid item xs={12}>
            <Typography variant={"caption"}>Base Advisor Fee</Typography>
            <Typography variant={"h6"}>
              <PercentageNumber
                value={baseAdvisorFee}
                needCalculation={false}
              />
            </Typography>
            <Typography variant={"caption"}>Advisor Fee Adjustment</Typography>
            <Typography variant={"h6"} color={"primary"}>
              <IconButton
                size={"small"}
                aria-label="Decrease Advisor Fee"
                onClick={adjustFee(-0.05)}
                disabled={portfolioAdvisorFee.equals(0)}
              >
                <RemoveIcon color="primary" />
              </IconButton>
              <PercentageNumber
                value={feeAdjustment}
                needCalculation={false}
                showSign={true}
              />
              <IconButton
                size={"small"}
                aria-label="Increase Advisor Fee"
                onClick={adjustFee(0.05)}
                disabled={portfolioAdvisorFee.equals(1.75)}
              >
                <AddIcon color="primary" />
              </IconButton>
            </Typography>
            <Divider style={{ margin: "10px 0" }} />
            <Typography variant={"caption"}>Net Advisor Fee</Typography>
            <Typography variant={"h6"}>
              <PercentageNumber
                value={portfolioAdvisorFee}
                needCalculation={false}
              />
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseModal}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={props.savePortfolioAdvisorFee(
            portfolioAdvisorFee.toNumber()
          )}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PortfolioAdvisorFeeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  baseAdvisorFee: PropTypes.number.isRequired,
  portfolioAdvisorFee: PropTypes.number.isRequired,
  savePortfolioAdvisorFee: PropTypes.func.isRequired,
};

export default withStyles(styles)(PortfolioAdvisorFeeModal);



// WEBPACK FOOTER //
// ./src/containers/Portfolio/components/PortfolioAdvisorFeeModal/index.jsx